import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { NavbarComponent } from './component/navbar/navbar.component';
import { TranslateModule} from '@ngx-translate/core';
import { BuscarCasoComponent } from './component/forms/buscar-caso/buscar-caso.component';
import { FormsModule } from '@angular/forms';
import { AgregarPersonasComponent } from './component/forms/agregar-personas/agregar-personas.component';
import { BuscarPersonaComponent } from './component/forms/buscar-persona/buscar-persona.component';
import { EvaluationMenuComponent } from './component/evaluation-menu/evaluation-menu.component';
import { FactorsComponent } from './component/factors/factors.component';
import { TransaccionesClienteComponent } from './component/forms/transacciones-cliente/transacciones-cliente.component';
import { AddcaseGeneralDataComponent } from '../pld/add-case/component/addcase-general-data/addcase-general-data.component';
import { AddcaseTransactionsComponent } from '../pld/add-case/component/addcase-transactions/addcase-transactions.component';
import { DetailOperacionesComponent } from '../pld/detail-case-management/detail-operaciones/detail-operaciones/detail-operaciones.component'
import { DynamicTableModule } from '@spot-utils/dynamic-table';


@NgModule({
	imports: [RouterModule, CommonModule, TranslateModule, FormsModule, DynamicTableModule], 
	declarations: [
		SidebarComponent,
		NavbarComponent,
		BuscarCasoComponent,
		AgregarPersonasComponent,
		BuscarCasoComponent,
		BuscarPersonaComponent,
		TransaccionesClienteComponent,
		EvaluationMenuComponent,
		FactorsComponent,
		AddcaseGeneralDataComponent,
		AddcaseTransactionsComponent,
		DetailOperacionesComponent,
	],
	exports: [
		SidebarComponent,
		NavbarComponent,
		TranslateModule,
		BuscarCasoComponent,
		AgregarPersonasComponent,
		BuscarPersonaComponent,
		TransaccionesClienteComponent,
		EvaluationMenuComponent,
		FactorsComponent,
		AddcaseGeneralDataComponent,
		AddcaseTransactionsComponent,
		DetailOperacionesComponent,
	],
})
export class SharedModule {}
